"use strict";
var $j = jQuery.noConflict();
var $scroll = 0;
var header_height = 100;

function shrinkHeader(){
	var screenPosition = $j(document).scrollTop();
	
	if(Foundation.MediaQuery.atLeast('large')){
		if(screenPosition > 230){
			$j('header.header').addClass('shrink');
		}
		else{
			$j('header.header').removeClass('shrink');
		}
	}
}

/*
function inlineRetinaImages() {
	var elems = document.getElementsByClassName('hero'); console.log(elems);
	
	if(typeof(elems) != 'undefined' && elems != null && window.devicePixelRatio >= 1.2){
		for(var i=0;i < elems.length;i++){
			var attr = elems[i].getAttribute('data-2x');
			if(attr){
				elems[i].style.cssText += 'background-image: url('+attr+')';
			}
		}
	}
}
inlineRetinaImages();
*/

function hero_slider_caption_margin() {
	if( $j('.hero-slider').length && Foundation.MediaQuery.is('medium down') ) {
		var captionHeight = $j('.hero-slider .caption').height();
		$j('.hero-slider').css('margin-bottom', captionHeight);
	}
	else if( Foundation.MediaQuery.is('tablet up') ) {
		$j('.hero-slider').css('margin-bottom', '');
	}
}

$j(window).on('load', function() {
	//shrinkHeader();
});

$j(window).on('scroll', function() {
	//shrinkHeader();
	var showAfter = 250;
	if( $j(this).scrollTop() > showAfter && Foundation.MediaQuery.atLeast('phone') ) {
		$j('.back-to-top').fadeIn();
	}
	else {
		$j('.back-to-top').fadeOut();
	}
});

$j(window).on('resize', function() {
	//hero_slider_caption_margin();
	if( $j('.hero-slider').length && Foundation.MediaQuery.is('medium down') ) {
		var captionHeight = $j('.hero-slider .caption').height();
		$j('.hero-slider').css('margin-bottom', captionHeight);
	}
	else if( Foundation.MediaQuery.is('tablet up') ) {
		$j('.hero-slider').css('margin-bottom', '');
	}
});

$j(document).ready(function($) {	
	if( $j('.hero-slider').length && Foundation.MediaQuery.is('medium down') ) {
		var captionHeight = $j('.hero-slider .caption').height();
		$j('.hero-slider').css('margin-bottom', captionHeight);
	}
	else if( Foundation.MediaQuery.is('tablet up') ) {
		$j('.hero-slider').css('margin-bottom', '');
	}
	
	$('.back-to-top').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({scrollTop: 0}, 800);
	});
	
	if( $('.cboxGroup').length ){
		$('.cboxGroup').colorbox({
			rel: 'group1',
			maxWidth: '100%',
			maxHeight: '100%',
			title: function() {
				return $(this).siblings('.wp-caption-text').html();
			}
		});
	}
	
	if( $('.colorbox').length ) {
		$('.colorbox').colorbox({
			maxWidth: '100%',
			maxHeight: '100%',
			title: function() {
				return $(this).siblings('.wp-caption-text').html();
			},
			rel: function() {
				return $(this).data('rel');
			}
		})
	}
	
	if( $('.sponsor-carousel').length ){
		$('.sponsor-carousel').slick({
			dots: false,
			arrows: true,
			autoplay: true,
			//lazyLoad: 'ondemand',
			infinite: true,
			speed: 1000,
			slidesToShow: 4,
			responsive: [
/*
				{
					breakpoint: 1170,
					settings: {
						slidesToShow: 5,
					}
				},
*/
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 2,
					}
				},

				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
					}
				},

				{
					breakpoint: 380,
					settings: {
						slidesToShow: 1,
					}
				},
			]
		});
	}
	
	if( $('.click-row').length ) {
		$('.click-row tbody').on('click', function(){
			var href = $(this).find('a').attr('href');
			if(href) {
				window.location = href;
			}
		})
	}
});